import { v4 } from 'uuid';

export const createUUID = () => window.crypto?.randomUUID?.() || v4();
